import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm leading-none font-semibold transition-colors duration-300 ring-offset-neutral-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:transition-all",
  {
    variants: {
      variant: {
        "default": [
          "bg-orange-500 text-white",
          "hover:bg-orange-800",
          "active:bg-neutral-900",
          "disabled:bg-neutral-800 disabled:text-neutral-500",
        ],

        "outline": [
          "bg-white border border-neutral-300 [&_svg]:text-orange-500",
          "hover:bg-orange-100 hover:text-orange-500",
          "active:bg-orange-100 active:border active:border-orange-500 active:text-orange-500",
          "disabled:bg-neutral-100 disabled:border disabled:border-neutral-300 disabled:text-neutral-400 [&_svg]:disabled:text-neutral-400",
        ],

        "dark": [
          "bg-neutral-800 text-white",
          "hover:bg-neutral-600",
          "disabled:text-neutral-500 disabled:bg-neutral-800",
        ],

        "nav-link": [
          "justify-start text-xs font-medium text-neutral-900 w-full",
          "hover:bg-orange-100 hover:text-neutral-900 [&_svg]:hover:text-orange-500",
          "disabled:text-neutral-400 [&_svg]:disabled:text-neutral-400",
        ],

        "mobile-nav-link": [
          "flex-col justify-center gap-0 text-xs font-medium text-neutral-900 w-full",
          "hover:bg-orange-100 hover:text-neutral-900 [&_svg]:hover:text-orange-500",
          "disabled:text-neutral-400 [&_svg]:disabled:text-neutral-400",
        ],

        "ghost": [
          "bg-transparent text-white underline font-normal",
          "disabled:text-neutral-400",
        ],
      },
      size: {
        default: "h-12 px-4 py-2",
        compact: "size-9 py-1 px-2 rounded-lg",
      },
      loading: {
        true: "[&_svg]:size-8 [&_svg]:duration-700",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      loading: false,
    },
    compoundVariants: [
      {
        variant: ["mobile-nav-link", "nav-link"],
        loading: false,
        className: "[&_svg]:size-6",

      },
      {
        variant: ["default", "dark"],
        loading: true,
        className: "[&_svg]:size-8 [&_svg]:duration-700 pointer-events-none bg-neutral-800",
      },
    ],
  },
);
